import { cn } from '@/utils/style';

interface FieldLabelProps {
  label?: string;
  children?: React.ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
}

export function FieldLabel(props: FieldLabelProps) {
  const { label, children, error, required, className } = props;

  return (
    <div className={cn('flex flex-col gap-1 w-full', className)}>
      <div className="text-sm font-medium text-gray-600">
        {label && label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </div>
      {children}
      {error && <div className="text-sm text-red-600">{error}</div>}
    </div>
  );
}
